import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import VueMeta from 'vue-meta'

import { startPageScrollLockObserver } from '@sigma-frontend-libs/commons'

import mixins from '@/mixins'
import store from '@/store'
import { createCaughtError, handleCaughtError, locales, projectName, registerErrorInterception, registerSW } from '@/utils'

import { Components } from '@/components/g'

import 'prismjs/themes/prism-okaidia.css'

import '@/assets/main.scss'

import '@/plugins/numeral'

import GTooltip from '@/plugins/gTooltip'
import { router } from '@/plugins/router'

import app from '@/app'

const swRecoveryStorageKey = 'swRecovery'
try {
  window.sessionStorage.removeItem(swRecoveryStorageKey)
} catch (error) {
  console.error(`Failed to remove ${swRecoveryStorageKey} from sessionStorage`, error)
}

const instructionElement = document.querySelector('.instruction')
if (instructionElement && typeof instructionElement.remove === 'function') {
  instructionElement.remove()
}

Vue.use(VueMeta)
Vue.use(GTooltip)

startPageScrollLockObserver()

registerErrorInterception()

for (const name in Components) {
  Vue.component(name, Components[name])
}

Vue.mixin(mixins)

const tokenKey = `${projectName}:token`
const initToken = window.localStorage.getItem(tokenKey)
store.dispatch('authentication/setToken', initToken, { root: true })

window.onstorage = event => {
  if (document.hidden) {
    switch (event.key) {
      case tokenKey:
      case 'prevToken': {
        window.location.reload()
        break
      }
    }
  }
}

store.dispatch('viewport/init', null, { root: true })
store.dispatch('global/setPlatform', null, { root: true })
store.dispatch('global/setBrowser', null, { root: true })

registerSW()
window.addEventListener('mouseup', () => {
  return store.dispatch('authentication/setTimer', null, { root: true })
})
window.addEventListener('keyup', () => {
  return store.dispatch('authentication/setTimer', null, { root: true })
})

let locale = window.location.href.replace(/.*?#.*?\?.*?locale=([A-z]+)(&|$)/, '$1')
locale = locale.replace(/.*?\/\/(.*?)\..*/, '$1')

if (!~locales.indexOf(locale)) {
  locale = window.localStorage.getItem('locale')

  if (!~locales.indexOf(locale)) {
    const domains = window.location.hostname.split('.')
    const topLevelDomain = domains[domains.length - 1]
    switch (topLevelDomain) {
      case 'com': {
        locale = 'en'
        break
      }
      case 'ru':
      default: {
        locale = 'ru'
        break
      }
    }
  }

  if (!~locales.indexOf(locale)) {
    locale = 'ru'
  }
}

store.dispatch('locale/setLocale', locale)

function mountApplication() {
  new Vue({
    router,
    store,
    render: h => {
      return h(app)
    }
  }).$mount('#app')
}

store.dispatch('authentication/setAccountFromToken', null, { root: true })
  .catch(error => {
    return handleCaughtError(createCaughtError('startup', error))
  })
  .then(mountApplication)
